import { render } from "./InactividadClose.vue?vue&type=template&id=62c1cb56"
import script from "./InactividadClose.vue?vue&type=script&lang=js"
export * from "./InactividadClose.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__